export default function IconTeamsBrand(props: { size?: number }) {
  const { size = 24 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <circle cx="18.5" cy="5.5" r="2.5" fill="#7b83eb" />
      <path fill="#7b83eb" d="M16.5 9.5h4.7c.44 0 .8.36.8.8v4.2a3.5 3.5 0 0 1-3.5 3.5h-2z" />
      <rect x="2" y="7" width="13" height="13" rx="2" fill="#5059c9" />
      <path fill="#ffffff" d="M5.5 10v1.6h2.2V17h1.6v-5.4h2.2V10z" />
    </svg>
  );
}
